import "./effort.css";

export type CalculationType = "percent_of_total" | "fixed_hours";

interface Props {
  value: CalculationType | undefined;
  onChange: (value: CalculationType) => void;
  /** The unit effort is measured in: "hours", or a project's units/days. */
  unitLabel?: string;
  name?: string;
}

interface CardProps {
  type: CalculationType;
  title: string;
  description: string;
}

// The large percent-vs-fixed choice from the settings governance form.
export const CalculationTypeCards = ({
  value,
  onChange,
  unitLabel = "hours",
  name = "calc-type",
}: Props) => {
  const Card = ({ type, title, description }: CardProps) => {
    const selected = value === type;
    return (
      <div className="col-sm-6">
        <label className={`governanceEffortCard ${selected ? "selected" : ""}`}>
          <input
            type="radio"
            name={name}
            value={type}
            checked={selected}
            onChange={() => onChange(type)}
            className="governanceEffortCardInput"
          />
          <span className="governanceEffortRadio" aria-hidden>
            {selected && <span className="governanceEffortRadioInner" />}
          </span>
          <span className="governanceEffortCardText">
            <span className="governanceEffortCardTitle">{title}</span>
            <span className="governanceEffortCardDesc">{description}</span>
          </span>
        </label>
      </div>
    );
  };

  return (
    <>
      <div className="governanceEffortHelp">
        How should we calculate governance effort?
      </div>
      <div className="row governanceEffortCardRow">
        <Card
          type="percent_of_total"
          title="Calculate governance effort"
          description={`Calculate governance effort as a percentage of ${unitLabel}`}
        />
        <Card
          type="fixed_hours"
          title="Set fixed governance effort"
          description={`Set governance effort as a fixed number of ${unitLabel}`}
        />
      </div>
    </>
  );
};
